import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { Authenticator } from '@aws-amplify/ui-react';
import { Amplify } from 'aws-amplify';
import outputs from '../amplify_outputs.json';
import { Toaster } from '@/components/ui/toaster';
import { BrowserRouter } from 'react-router-dom';

//fonts
import '@fontsource/oswald'; // default for headings
import '@fontsource/roboto-condensed'; // default for body text
import AppBackground from './components/AppBackground/index.tsx';
import { ThemeProvider } from './components/Theme/ThemeProvider.tsx';

Amplify.configure(outputs);

console.info('Amplify Configuration:', outputs);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <React.StrictMode>
      <Authenticator.Provider>
        <ThemeProvider defaultTheme="system" storageKey="icehawk-theme">
          <App />
          <AppBackground />
          <Toaster />
        </ThemeProvider>
      </Authenticator.Provider>
    </React.StrictMode>
  </BrowserRouter>
);
